// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U2oFSSm2rIDa0gUGFEbv{margin:0 8px}.qC1DaTMMf3AGGjeBnHhN{margin:0 16px}.v4JLoiu6Dgp7R2YbUeIc{padding:7px 12px}.v4JLoiu6Dgp7R2YbUeIc>:first-child{cursor:pointer;align-items:center;height:auto;min-height:26px;display:flex}.L3uYSAcYOQcPAzvy981G{color:var(--content-primary-disabled);flex-wrap:wrap;align-items:center;gap:4px;font-size:13px;font-weight:400;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `U2oFSSm2rIDa0gUGFEbv`,
	"selectWrap": `qC1DaTMMf3AGGjeBnHhN`,
	"enrollField": `v4JLoiu6Dgp7R2YbUeIc`,
	"preview": `L3uYSAcYOQcPAzvy981G`
};
export default ___CSS_LOADER_EXPORT___;
